import { Badge as SparkBadge } from '@uswitch/spark.badge'

import * as st from './styles'

// TODO: Update CommsUI and import from SparkIcons
const Icon = ({ className }) => (
  <svg className={className} width='16' height='16' viewBox='0 0 32 32'>
    <path
      d='M12 12.5C12 10.0147 14.0147 8 16.5 8H16.7273C19.087 8 21 9.91296 21 12.2727H19C19 11.0175 17.9825 10 16.7273 10H16.5C15.1193 10 14 11.1193 14 12.5V15H20V17H14V21H21V23H12V17H10V15H12V12.5Z'
      fill='currentColor'
    />
  </svg>
)

const Badge = (text) => {
  return (
    <SparkBadge sx={st.badgeStyle} as='span' variant='dark'>
      <Icon sx={st.iconStyle} />
      {text}
    </SparkBadge>
  )
}

export default Badge
